<template>
  <a-layout-content :style="{ padding: '10px' }">
    <a-spin size="large" :spinning="pageLoading">
      <div style="min-height: 100vh">
        <a-tooltip title="Geri">
          <button class="btn-back">
            <img
              src="../../../assets/imgs/return.png"
              class="back-img"
              @click="goBack"
            />
          </button>
        </a-tooltip>

        <problem-header v-if="problem" :problem="problem"></problem-header>

        <a-row type="flex" :gutter="24" v-if="problem">
          <a-col span="24">
            <a-row type="flex" :gutter="24">
              <a-col
                :span="15"
                style="height: max-content"
                class="image__container"
              >
                <conditional-media
                  :filesList="problem.files"
                ></conditional-media>

                <p class="username" v-if="problem.addUser">
                  {{
                    problem.addUser.firstName +
                    " " +
                    problem.addUser.lastName +
                    " " +
                    problem.addUser.fatherName
                  }}
                </p>

                <p class="title" style="overflow-wrap: anywhere;">{{ problem.title }}</p>

                <p class="date-txt" v-if="problem">
                  {{ problem.dateStr }}
                  <a-icon type="clock-circle" style="margin-right: 7px" />
                </p>

                <div
                  v-if="getCategoriesOfProblem.length > 0"
                  style="
                    display: flex;
                    align-items: flex-start;
                    margin: 0 6px 10px;
                  "
                >
                  <p style="margin-right: 15px; margin-bottom: 0">Müraciətin təsnifatı:</p>

                  <div
                    style="
                      margin-right: 15px;
                      display: flex;
                      width: 100%;
                      flex-wrap: wrap;
                    "
                  >
                  <!-- {{getCategoriesOfProblem}} -->
                    <a-tag
                      v-for="category in getCategoriesOfProblem"
                      :key="category.uuid||''"
                      color="#108ee9"
                      style="
                        display: flex;
                        align-items: center;
                        max-width: 100%;
                        white-space: break-spaces;
                        margin-bottom: 5px;
                      "
                    >
                      {{ category.name }}
                      {{
                        category.parent
                          ? `(${category.parent.name.toLowerCase()})`
                          : ""
                      }}
                    </a-tag>
                  </div>
                </div>
              </a-col>

              <a-col :span="9" class="operation-panel image__container">
                <div class="detailed">
                  <a-button
                    v-if="
                      privilege.selectParentOffice === 'REQUIRED' ||
                      privilege.selectParentOffice === 'OPTIONAL'
                    "
                    @click="addOfficeDetail(null)"
                    style="margin-right: 10px"
                  >
                Qurum əlavə et
                  </a-button>

                  <a-button
                    v-if="privilege.selectRepresentation"
                    style="margin-right: 10px"
                    :class="{ colorflashing: !problem.representation }"
                    @click="representationModalVisibility = true"
                    >Məsul əməkdaş təyin et</a-button
                  >

                  <!--  <a-button
                    v-if="currentStep.canIdentifyStreet"
                    style="margin-right: 10px;"
                    :class="{ colorflashing: !problem.street }"
                    @click="addrModalVis = true"
                    >Ünvanı müəyyənləşdir</a-button
                  > -->

                  <a-button
                    type="default"
                    @click="showDetailed(problem)"
                    style="text-align: right"
                    >Ətraflı</a-button
                  >
                </div>

                <div v-if="problem.execStructures.length > 0">
                  <div
                    style="
                      background-color: #e6f7ff;
                      border: 1px solid #91d5ff;
                      padding: 10px;
                      border-radius: 5px;
                    "
                  >
                    <!-- {{'İcraçı təşkilatlar: ' +
                      problem.execStructures.map((item) => item.name + (!item.isApproved? ' (təsdiq olunmayib)':'') ).join(', ')}}  -->
                   Qurumlar:
                    <div v-for="x in problem.execStructures" :key="x.id">
                     {{
                        x.name + (!x.isApproved ? " (təsdiq olunmayib)" : "")
                      }}

                       <a-button
                       style="float:right"
                        v-if="
                        currentStep.canApproveParentOffice&&
                          !x.isApproved &&
                          (privilege.selectParentOffice === 'REQUIRED' ||
                            privilege.selectParentOffice === 'OPTIONAL')
                        "
                        size="small"
                        @click="addOfficeDetail(x)"
                        >Təsdiq et</a-button
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="last-op"
                  v-if="
                    problem &&
                    problem.lastOperation &&
                    problem.lastOperation.opUser &&
                    privilege.workWithDetails
                  "
                >
                  <p>Əvvəlki əməliyyat</p>
                  <p>
                    {{ getOperationText(problem.lastOperation) }}
                    <a-tooltip
                      v-if="problem.lastOperation.note"
                      :title="problem.lastOperation.note"
                    >
                      <a-icon type="message" />
                    </a-tooltip>

                    <a-button
                      style="
                        float: right;
                        top: 15px;
                        background-color: #fff;
                        color: black;
                        border-radius: 5px;
                      "
                      size="small"
                      v-if="problem.lastOperation.files.length > 0"
                      @click="showMediaFiles(problem.lastOperation.files)"
                    >
                      Fayllara bax
                    </a-button>
                  </p>
                </div>

                <div v-if="problem && privilege.selectExecutive">
                  <p class="REQUIRED">Yerli icra hakimiyyəti orqanı</p>
                  <a-select
                    v-model="selectedExecutiveId"
                    showSearch
                    :filterOption="false"
                    @search="searchExecs"
                    placeholder="Zəhmət olmasa Yerli icra hakimiyyəti orqanı seçin"
                  >
                    <a-select-option v-for="x in filterExecutives" :key="x.id">
                      {{ x.name }}
                    </a-select-option>
                  </a-select>
                </div>

                <!--Office Details in generally-->
                <div
                  v-if="
                    (privilege.selectParentOffice === 'REQUIRED' ||
                      privilege.selectParentOffice === 'OPTIONAL') &&
                    !privilege.workWithDetails
                  "
                >
                  <a-card
                    hoverable
                    v-for="(detOffice, index) in problem.officeDetails"
                    :key="index"
                  >
                    <a-button
                      v-if="detOffice.clientId"
                      style="position: absolute; right: 5px; top: 5px"
                      type="danger"
                      shape="circle"
                      icon="close-circle"
                      @click="handleRemove(detOffice)"
                    >
                    </a-button>

                    <div
                      v-if="
                        (privilege.selectParentOffice === 'REQUIRED' ||
                          privilege.selectParentOffice === 'OPTIONAL') &&
                        detOffice.isNew
                      "
                      style="margin-bottom: 10px"
                    >
                      <p>Digər təşkilat</p>
                      <a-select
                        v-model="detOffice.selectedParentOfficeId"
                        placeholder="Zəhmət olmasa təşkilat seçin"
                        showSearch
                        :filterOption="false"
                        @search="searchOffices"
                        @change="
                          (e) => handleParentOfficeChange(e, detOffice, index)
                        "
                      >
                        <a-select-option
                          v-for="x in officesFiltered"
                          :key="x.id"
                        >
                          {{ x.name }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div style="margin-bottom: 10px" v-if="detOffice.isNew">
                      <p>Qeyd</p>
                      <a-textarea

                        :autoSize="{ minRows: 2, maxRows: 6 }"
                        v-model="detOffice.noteField"
                      ></a-textarea>
                    </div>

                    <my-file-upload
                      v-if="detOffice.isNew"
                      ref="fileUpload"
                      :filesList="detOffice.fileList"
                      :pkey="'detOffice' + index"
                      :max="5"
                      @upload-change="(e) => handleUploadChange(e, detOffice)"
                    ></my-file-upload>
                  </a-card>
                </div>

                <div
                  v-if="
                    privilege &&
                    !privilege.workWithDetails &&
                    (privilege.selectSubOffice === 'REQUIRED' ||
                      privilege.selectSubOffice === 'OPTIONAL')
                  "
                >
                  <p>İdarə</p>
                  <a-select
                    v-model="selectedOfficeId"
                    allowClear
                    placeholder="Zəhmət olmasa təşkilat seçin"
                  >
                    <a-select-option v-for="x in offices" :key="x.id">{{
                      x.name
                    }}</a-select-option>
                  </a-select>
                </div>

                <div class="test" v-if="privilege.workWithDetails">
                  <operation-detail
                    ref="operationdetail"
                    :problem="problem"
                    :privilege="privilege"
                    @submit="handleOpSubmit"
                    @removed="handleRemove"
                    :noExecutorWarning="false"
                    :structures="problem.execStructures"
                  ></operation-detail>
                </div>

                <div
                  v-if="
                    privilege &&
                    !privilege.workWithDetails &&
                    (privilege.selectExecutor === 'REQUIRED' ||
                      privilege.selectExecutor === 'OPTIONAL')
                  "
                >
                  <div>
                    <p style="float: left">İcraçı</p>
                    <!--  <a-button type="default" @click="newExecutor" style="border:none;color:#1890ff;float:right;">Yeni icraçı</a-button> -->
                  </div>
                  <a-select
                    v-model="selectedExecutorUUID"
                    placeholder="Zəhmət olmasa icraçı seçin"
                    allowClear
                  >
                    <a-select-option
                      v-for="executor in executors"
                      :value="executor.id"
                      :key="executor.id"
                    >
                      {{
                        executor.firstName +
                        " " +
                        executor.lastName +
                        " (" +
                        executor.taskCount +
                        " tapşırıq)"
                      }}
                    </a-select-option>
                  </a-select>
                </div>

                <div
                  v-if="
                    privilege &&
                    !privilege.workWithDetails &&
                    (privilege.selectExecutor === 'REQUIRED' ||
                      privilege.selectExecutor === 'OPTIONAL')
                  "
                >
                  <p>İcra son tarixi</p>
                  <a-date-picker
                    format="YYYY-MM-DD"
                    :disabledDate="disabledDate"
                    :showTime="false"
                    placeholder="İcranın son tarixini seçin"
                    v-model="executeLastDate"
                  />
                </div>

                <div
                  v-if="
                    privilege &&
                    !privilege.workWithDetails &&
                    problem.officeDetails.length > 0 &&
                    problem.officeDetails[0].lastOpUserNote
                  "
                >
                  <a-alert
                    :message="
                      problem.officeDetails[0].lastOpUserStep + ' qeydi '
                    "
                    :description="problem.officeDetails[0].lastOpUserNote"
                    type="success"
                  />
                </div>

                <div v-if="privilege && !privilege.workWithDetails">
                  <p class="REQUIRED">Qeyd</p>
                  <a-textarea

                    :autoSize="{ minRows: 2, maxRows: 6 }"
                    v-model="problem.noteField"
                  ></a-textarea>
                </div>

                <div
                  v-if="
                    privilege &&
                    !privilege.workWithDetails &&
                    currentStep.fileAnswer
                  "
                  style="overflow: auto"
                >
                  <p>Fayllar</p>
                  <my-file-upload
                    ref="fileUpload"
                    :filesList="fileList"
                    pkey="problem"
                    :max="5"
                    @upload-change="(e) => handleUploadChange(e, fileList)"
                  ></my-file-upload>
                </div>

                <div
                  v-if="privilege && !privilege.workWithDetails"
                  class="actions-container"
                >
                  <a-button
                    v-for="button in buttons"
                    :key="button.id"
                    @click="submit(button)"
                    :style="{ backgroundColor: button.color }"
                    >{{ button.name }}
                  </a-button>
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>

        <not-found-problem v-if="resNotFound"></not-found-problem>

        <detail-modal
          :visible="modalVisible"
          :problemOb="problem"
          @afterClose="handleModalClose"
        ></detail-modal>

        <address-modal
          :visible="addrModalVis"
          :problem="problem"
          @after-close="handleAddrModalClose"
          @success="handleAddrSuccess"
        ></address-modal>
        <AddOfficeModal
        :selectedPOffice="selectedPOffice"
          :problem="problem"
          :privilege="privilege"
          :visible="opDetailVisibility"
           @afterClose="handleAddOffModalClose"
        />

        <!--Representation modal-->
        <representation-modal
          :visible="representationModalVisibility"
          :problem="problem"
          @afterClose="handleRepAfterClose"
          @change="handleRepChange"
        ></representation-modal>
      </div>
    </a-spin>
  </a-layout-content>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
// import { mapGetters, mapMutations, mapActions } from "vuex";
import mixin from "@/mixins/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import moment from "moment";
import DetailModal from "@/components/pages/Modals/DetailModal/index";
import AddOfficeModal from "@/components/pages/Modals/AddOfficeModal/index";
import AddressModal from "@/components/pages/Modals/AddressModal/index";
import CitizenList from "@/components/partials/CitizenList/index";
import NotFoundProblem from "@/components/partials/NotFoundProblem";
import RepresentationModal from "@/components/pages/Modals/RepresentationModal/index";
import OperationDetail from "@/components/partials/OperationDetail/index";
import ProblemHeader from "@/components/partials/ProblemHeader/index";
import MyFileUpload from "@/components/partials/MyFileUpload";
import OperationCard from "@/components/partials/OperationCard";

export default {
  name: "ActionDetails",
  mixins: [mixin],
  components: {
    "conditional-media": ConditionalMedia,
    VNodes: { functional: true, render: (_h, ctx) => ctx.props.vnodes },
    "detail-modal": DetailModal,
    "citizen-list": CitizenList,
    "not-found-problem": NotFoundProblem,
    "representation-modal": RepresentationModal,
    "operation-detail": OperationDetail,
    "problem-header": ProblemHeader,
    "address-modal": AddressModal,
    "my-file-upload": MyFileUpload,
    AddOfficeModal,
    OperationCard,
  },
  data() {

    return {
      opDetailVisibility: false,
      submitLoading: false,
      statuses: [],
      representationModalVisibility: false,
      buttons: [],
      problem: null,
      representations: [],
      offices: [],
      officesFiltered: [],
      executors: [],
      avtiveKey: null,
      selectedExecutiveId: null,
      initialOfficeIds: [],
      selectedRepresentationId: null,
      selectedOfficeId: null,
      selectedExecutorUUID: null,
      executeLastDate: null,
      privilege: null,
      fileList: [],
      files: [],
      selectedAction: null,
      modalVisible: false,
      selectedDetOffice: null,
      myconfirmVis: false,
      resNotFound: false,
      initialOffices: [],
      willDeletedOffices: [],
      addrModalVis: false,
      actionsForNewOff: null,
      filterExecutives: [],
      executives: [],
      selectedPOffice: null,
    };
  },

  watch: {
    problem: {
      immediate: true,
      handler: function (_newVal) {

      },
    },
  },
  computed: {
    problemGenOfficeDetails: function () {
      return (this.privilege.selectParentOffice === "REQUIRED" ||
        this.privilege.selectParentOffice === "OPTIONAL") &&
        !this.privilege.workWithDetails
        ? this.problem.officeDetails
        : [];
    },
    getCategoriesOfProblem: function () {

      if (this.problem.officeDetails.map(item=>item?.category).filter(item=>item!=null).length>0) {
        return  this.problem.officeDetails.map(item=>item?.category).filter(item=>item!=null);
      } else if( this.problem.categories){
        return this.problem?.categories||[]
      }else{
        return []
      }


    },
  },
  methods: {
    moment,
    goBack() {
      this.$router.push("/main");
    },

    handleOfficeAddClose() {

      this.selectedPOffice = null;
    },
    handleAddOffModalClose() {
      this.opDetailVisibility = false;
    },
    disabledDate(current) {
      return current && current < moment().endOf("day");
    },
    handlePhoneKeyDown(e) {
      if (isNaN(Number(e.key))) e.preventDefault();
    },
    searchExecs(key) {
      const regex = new RegExp(key, "i");
      this.filterExecutives = this.executives.filter((item) =>
        regex.test(item.name.toLowerCase())
      );
    },
    searchOffices(key) {
      const regex = new RegExp(key, "i");
      this.officesFiltered = this.offices.filter((item) =>
        regex.test(item.name.toLowerCase())
      );
    },
    handleUploadChange( e, fileList) {

      this.fileList = e;
    },
    addOfficeDetail(parenToffice) {
      console.log({parenToffice});
      this.selectedPOffice = parenToffice;
      this.opDetailVisibility = true;
      /*       let newOfficeDetail = {
        clientId: this.problem.officeDetails.length + 1,
        office: null,
        noteField: null,
        isNew: true,
        fileList: [],
      };

      const newOfficeDetails = [newOfficeDetail, ...this.problem.officeDetails];
      this.problem = {
        ...this.problem,
        officeDetails: newOfficeDetails,
      }; */

      // this.problem.officeDetails.push(newOfficeDetail);
    },
    handleRepChange(rep) {
      this.$set(this.problem, "representation", rep);
      this.representationModalVisibility = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    checkIfDisabled(office) {
      return (
        !this.currentStep.uncheckOffice &&
        this.initialOfficeIds.indexOf(office.id) !== -1
      );
    },
    handleMyConfirmClose() {
      this.myconfirmVis = false;
    },
    getFilteredOffices() {
      this.getExecutorStructures().then((response) => {
        if (!response.data.error) {
          // evvelceden secilmis ust idareleri cixardiram ki secmesin
          this.offices =
            this.privilege.selectParentOffice === "REQUIRED" ||
            this.privilege.selectParentOffice === "OPTIONAL"
              ? response.data.data.entities.filter(
                  (item) => this.initialOfficeIds.indexOf(item.id) === -1
                )
              : response.data.data.entities;
          this.officesFiltered = this.offices;
        }
      });
    },
    handleParentOfficeChange(val, officeDetail) {
      if (
        this.problem.officeDetails.filter(
          (item) => item.selectedParentOfficeId === val
        ).length > 1
      ) {
        this.$message.error("Bu qurum artıq seçilib");
        this.$set(officeDetail, "selectedParentOfficeId", null);
        return;
      }
      if (this.privilege.selectParentOffice) {
        officeDetail.parentOffice = { id: val };
      }
    },
    showConfirm(sendData, detailOffice, content) {
      const dataToSend = sendData;
      const message = this.$message;
      const destroyAll = this.$destroyAll;
      const set = this.$set;
      const operationdetail = this.$refs.operationdetail;
      const { problem, privilege } = this;
      this.$confirm({
        title: content,
        //content: content,
        okText: "Bəli",
        okType: "primary",
        cancelText: "Xeyr",
        onOk() {
          return new Promise((resolve, reject) => {
            apiCall({
              url:
                URL[process.env.NODE_ENV].service_api +
                "problems/" +
                problem.id,
              method: "PUT",
              data: dataToSend,
            })
              .then((response) => {
                if (!response.data.error) {
                  if (privilege.workWithDetails) {
                    destroyAll();
                    set(
                      problem,
                      "officeDetails",
                      problem.officeDetails.filter(
                        (item) => item.id !== detailOffice.id
                      )
                    );
                    operationdetail.removeSent(detailOffice.parentOffice.id);
                    message.info("Müraciət göndərildi.");
                    if (problem.officeDetails.length > 0) return;
                  } else {
                    message.info("Müraciət göndərildi.");
                  }

                  setTimeout(() => {
                    window.location.href = "/main";
                  }, 1000);
                } else {
                  message.error(response.data.error.message);
                  destroyAll();
                }
              })
              .catch((_err) => {
                destroyAll();
              });
          }).catch((err) => {
            // eslint-disable-next-line no-console

          });
        },
        onCancel() {

        },
      });
    },
    // handleUploadChange(fileList, officeDetail) {
    //   if (officeDetail) {
    //     officeDetail.fileList = fileList;
    //     return;
    //   }
    //   this.fileList = fileList;
    // },

    submit(button, detailOffice,commentarStructures, result) {

      if (
        !detailOffice &&
        button.askReason &&
        (!this.problem.noteField || this.problem.noteField.trim().length == 0)
      ) {
        this.$message.error("Qeyd mütləq daxil edilməlidir.");
        return;
      }
      let sendData = this.fillSendData(button, detailOffice);
      if (!sendData) return;
      sendData.result = result;
      sendData.commentarStructures=commentarStructures;
      if (
        (this.privilege.selectParentOffice === "REQUIRED" /* ||
          this.privilege.selectParentOffice === "OPTIONAL" */) &&
        button.dataRequired &&
        this.problem.execStructures.length === 0 &&
        sendData.newDetailOffices.length === 0
      ) {
        this.$message.error("Qurum mütləq seçməlidir.");
      } else {
        this.showConfirm(
          sendData,
          detailOffice,
          "Əlavə edilsin?  "
        );
      }
    },

    fillSendData(button, detailOffice) {
      let sendData = {
        offices: null,
        note: this.privilege.workWithDetails
          ? detailOffice.noteField
          : this.problem.noteField,
        action: button,
        executor: null,
        lastDateStr: null,
        detailOffice: null,
        files: this.privilege.workWithDetails
          ? detailOffice.fileList
          : this.fileList,
        confirm: this.selectedAction ? button : null,
      };

      if (
        (this.privilege.selectExecutor === "REQUIRED" ||
          this.privilege.selectExecutor === "OPTIONAL") &&
        button.dataRequired
      ) {
        sendData.executor = detailOffice.selectedExecutorUUID
          ? { uuid: detailOffice.selectedExecutorUUID }
          : null;
        sendData.lastDateStr = detailOffice.executeLastDate
          ? detailOffice.executeLastDate
              .format(this.opDatetimeFormat)
              .toString()
          : null;
        sendData.detailOffice = this.problem.officeDetails[0];
      }
      if (this.privilege.workWithDetails) {
        sendData.detailOffice = detailOffice;
      }
      if (
        (this.privilege.selectParentOffice === "REQUIRED" ||
          this.privilege.selectParentOffice === "OPTIONAL") &&
        button.dataRequired
      ) {
        if (this.workWithDetails) {
          sendData.offices = [{ id: detailOffice.selectedParentOfficeId }];
        } else {
          sendData.newDetailOffices = this.problem.officeDetails.filter(
            (item) => item.isNew
          );
          sendData.newDetailOffices.forEach((item) => {
            item.note = item.noteField;
            item.files = item.fileList;
          });
        }
        if (
          (this.privilege.selectParentOffice === "REQUIRED" ||
            this.privilege.selectParentOffice === "OPTIONAL") &&
          this.problem.execStructures.length === 0 &&
          sendData.newDetailOffices &&
          sendData.newDetailOffices.find((item) => !item.parentOffice)
        ) {
          this.$message.error("Zəhmət olmasa icraçı təşkilat əlavə edin");
          return null;
        }
      }

      if (
        this.privilege.selectCategory === "REQUIRED" &&
        (button.dataRequirementStatus === "NECESSARIES" ||
          button.dataRequirementStatus === "ALL")
      ) {
        sendData.category = { uuid: detailOffice.selectedCategoryUUID };
      }

      if (
        this.privilege.selectSubOffice === "REQUIRED" &&
        (button.dataRequirementStatus === "NECESSARIES" ||
          button.dataRequirementStatus === "ALL")
      ) {
        sendData.subOffice = { id: detailOffice.selectedOfficeId };
        sendData.detailOffice = this.problem.officeDetails[0];
      } else if (
        this.privilege.selectSubOffice === "OPTIONAL" &&
        detailOffice.selectedOfficeId &&
        button.dataRequirementStatus === "ALL"
      ) {
        sendData.subOffice = { id: detailOffice.selectedOfficeId };
        sendData.detailOffice = this.problem.officeDetails[0];
      }
      if (this.privilege.selectExecutive && button.dataRequired) {
        if (!this.selectedExecutiveId) {
          this.$message.error("Qurum mütləq seçilməlidir.");
          return null;
        }
        sendData.executive = { id: this.selectedExecutiveId };
      }
      sendData.currentUrl =
        window.location.pathname.split("/").length === 0
          ? ""
          : window.location.pathname.split("/")[1];
      return sendData;
    },
    handleOpSubmit({ button, detailOffice,commentarStructures, result }) {
      this.submit(button, detailOffice,commentarStructures, result);
    },
    handleRemove(officeDetail) {
      const newOfficeDetails = [...this.problem.officeDetails].filter(
        (item) => item.clientId !== officeDetail.clientId
      );

      this.problem = {
        ...this.problem,
        officeDetails: newOfficeDetails,
      };
    },
    getProblemDetails() {
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "problems/" +
          this.$route.params.id,
        method: "GET",
        params: {
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.problem = response.data.data;
            this.privilege = this.problem.privilege;
            if(this.problem.categories.length>0 && this.problem.officeDetails.length>0 && !this.problem.officeDetails[0].category){
              this.problem.officeDetails[0].category = this.problem.categories[0];
            }
            this.problem.officeDetails.forEach((officeDetail) => {
              this.$set(officeDetail, "clientId", null);
              if (
                (this.privilege.selectParentOffice === "REQUIRED" ||
                  this.privilege.selectParentOffice === "OPTIONAL") &&
                officeDetail.parentOffice
              ) {
                this.$set(
                  officeDetail,
                  "selectedParentOfficeId",
                  officeDetail.parentOffice.id
                );
              }
              officeDetail.fileList = [];
              if (this.privilege.workWithFeedbackResult) {
                officeDetail.restartCount = 0;
                officeDetail.assestments.forEach((as) => {
                  if (as.startAgain) {
                    officeDetail.restartCount++;
                  }
                });
              }
              if (officeDetail.category)
                this.$set(
                  officeDetail,
                  "selectedCategoryUUID",
                  officeDetail.category.uuid
                );
            });
            if (this.privilege.showCitizenList) {
              this.getCitizenAppeals({
                problemId: this.problem.id,
                detailed: false,
              });
            }
            if (
              this.privilege.selectParentOffice === "REQUIRED" ||
              this.privilege.selectParentOffice === "OPTIONAL"
            ) {
              this.getExecutorStructures().then((response) => {
                if (!response.data.error) {
                  this.offices = response.data.data.entities;
                  this.officesFiltered = this.offices;
                }
              });
            }
            if (
              this.privilege.selectSubOffice === "REQUIRED" ||
              this.privilege.selectSubOffice === "OPTIONAL"
            ) {
              this.getSubOffices().then((response) => {
                if (!response.data.error) {
                  this.offices = response.data.data.entities;
                }
              });
            }

            if (this.privilege.selectExecutive) {
              this.getExecutives();
            }
            if (!this.privilege.workWithDetails) {
              this.getActions(this.problem.id, null).then(
                (response) => (this.buttons = response.data.data)
              );
            }
          } else if (response.data.error.code === 1080) {
            this.$message.error(response.data.error.message);
            this.resNotFound = true;
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");

          this.pageLoading = false;
        });
    },
    handleAddrSuccess() {
      this.problem.street = {};
      this.addrModalVis = false;
    },
    showDetailed(_detail) {
      this.modalVisible = true;
    },
    handleModalClose() {
      this.modalVisible = false;
    },
    handleAddrModalClose() {
      this.addrModalVis = false;
    },
    sendBack() {
      const message = this.$message;
      const destroyAll = this.$destroyAll;
      const problem = this.problem;
      this.$confirm({
        // title: content,
        //content: "Dəyişiklik yadda saxlanılsın?",
        okText: "Bəli",
        okType: "primary",
        cancelText: "Xeyr",
        onOk() {
          return new Promise((resolve, reject) => {
            apiCall({
              url:
                URL[process.env.NODE_ENV].service_api +
                `problems/${problem.id}/sendBack`,
              method: "POST",
            })
              .then((response) => {
                if (!response.data.error) {
                  window.location.href = "/main";
                } else message.error(response.data.error.message);
              })
              .catch((_err) => {
                destroyAll();
              });
          }).catch();
        },
      });
    },
  },
  async created() {
    this.pageLoading = true;
    this.getProblemDetails();
    this.getExecutors();
  },
};
</script>

<style lang="scss" src="./index.scss"></style>
